<template>
  <Card
    :btnMsg="$t('paypalForm.btn_text')"
    @changeStep="changeStep"
    :embedded="embedded"
  >
    <div class="card-paypalForm">
      <div class="card-content">
        <div class="card-header">
          <div class="card-title-box">
            <div class="card-title" v-html="$t('paypalForm.title')"></div>
            <div class="card-text">{{ $t("paypalForm.text") }}</div>
          </div>
          <!-- <img :src="writerPic" /> -->
        </div>
        <a-form-model ref="paypalForm" :model="form" :rules="formRules">
          <div class="code-box">
            <a-form-model-item
              :label="$t('paypalForm.form_paypal')"
              prop="account"
            >
              <a-input
                :placeholder="$t('paypalForm.form_paypal_placeholder')"
                v-model="form.account"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item
              :label="$t('paypalForm.form_ensure_paypal')"
              prop="confirm_account"
            >
              <a-input
                :placeholder="$t('paypalForm.form_ensure_paypal_placeholder')"
                v-model="form.confirm_account"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
            <a-form-model-item
              :label="$t('paypalForm.form_paypal_name')"
              prop="name"
            >
              <a-input
                :placeholder="$t('paypalForm.form_paypal_name_placeholder')"
                v-model="form.name"
                size="large"
                type="primary"
              ></a-input>
            </a-form-model-item>
          </div>
        </a-form-model>
      </div>
    </div>
    <p slot="after-actions" class="done-support">
      {{ $t("thanksAll.supportText") }}
      <a href="mailto:customerservice8@yeah.net">customerservice8@yeah.net</a>
    </p>
  </Card>
</template>

<script>
import Card from "@/components/card.vue";
import { postSubmit } from "@/api/portal";

export default {
  components: {
    Card,
  },
  props: {
    embedded: { type: Boolean, default: false },
    value: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: {},
      writerPic: require("@/assets/writer.png"),
      formRules: {
        account: [
          {
            required: true,
            message: this.$t("paypalForm.form_paypal_placeholder"),
            trigger: "blur",
          },
        ],
        confirm_account: [
          {
            required: true,
            message: this.$t("paypalForm.form_ensure_paypal_placeholder"),
            trigger: "blur",
          },
          { validator: this.checkPaypal, trigger: "change" },
        ],
        name: [
          {
            required: true,
            message: this.$t("paypalForm.form_paypal_name_placeholder"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.form = this.value;
  },
  methods: {
    checkForm() {
      let bol = false;
      this.$refs.paypalForm.validate((valid) => {
        if (valid) {
          bol = true;
          return true;
        } else {
          bol = false;
          return false;
        }
      });
      return bol;
    },
    checkPaypal(rule, value, callback) {
      if (this.form.account !== this.form.confirm_account) {
        callback(new Error(this.$t("inputNotSame")));
      }
      callback();
    },
    prevStep(stepName) {
      this.$emit("prevStep", stepName);
    },
    changeStep() {
      let bol = this.checkForm();
      if (bol) {
        this.$emit("input", { ...this.form });
        postSubmit({
          order_id: this.form.order_id,
          area_id: this.form.area_id,
          channel_id: this.form.channel_id,
          nick_name: this.form.nick_name,
          email: this.form.email,
          // platform_id: this.form.platform_id,
          screenshots: this.form.screenshots,
          paypal: `${this.form.name}-${this.form.confirm_account}`,
        }).then((res) => {
          this.$parent.changeStep("thanksAll", this.form);
        });
      }
    },
  },
};
</script>

<style lang="scss">
.card-paypalForm {
  position: relative;
  width: 100%;
  .card-content {
    display: flex;
    flex-direction: column;
    gap: 0px;
  }
  .card-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 15px 0px;
    img {
      width: 120px;
      height: 120px;
      flex: 0 0 120px;
      margin: 0;
    }
  }
  .card-title {
    color: #1a2233;
    font-size: 24px !important;
    font-weight: 800;
    line-height: 1.25;
    white-space: nowrap;
  }
  .card-text {
    margin: 0 !important;
    color: #475569;
    font-size: 20px !important;
    word-wrap: break-word;
    line-height: 1.5;
    white-space: nowrap;
  }
  .code-box {
    display: grid;
    gap: 12px;
  }
  .code-box .ant-form-item {
    margin-bottom: 0;
  }
  .order-why-box {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    .order-why {
      font-size: 13px;
      font-weight: 400;
      color: #676767;
    }
    .order-answer {
      font-size: 15px;
      font-weight: 500;
      color: #1a1a1a;
    }
  }
  .van-swipe__indicator .van-swipe__indicator-item {
    background-color: #fff;
  }

  .van-swipe__indicator .van-swipe__indicator-item--active {
    background-color: #f4a300; /* 高亮颜色 */
  }
}
.card-wrapper--embedded > .done-support {
  width: 100%;
  margin: 12px 0 0;
}
@media (max-width: 480px) {
  .card-paypalForm .card-header {
    gap: 10px;
    margin: 15px 0px;
  }
  .card-paypalForm .card-header img {
    width: 64px;
    height: 64px;
    flex-basis: 64px;
  }
  .card-wrapper .card-paypalForm .card-title {
    font-size: 16px !important;
    margin-bottom: 2px !important;
  }
  .card-paypalForm .card-text {
    font-size: 10px !important;
  }
}
</style>
